const QuestionPublishResult = (props) => {
  return (
    <>
      {(props?.data?.data ?? []).length > 0 && (
        <>
          <table className=' table table-striped table-hover table-bordered'>
            <thead>
              <tr>
                <th>عنوان</th>
                <th>وضعیت</th>
              </tr>
            </thead>
            <tbody>
              {props.data.data.map((item, index) => (
                <tr key={index}>
                  <td>{item.questionTitle}</td>
                  <td>{item.message}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
      {(props?.data?.data ?? []).length === 0 && <>NO DATA</>}
    </>
  )
}

export default QuestionPublishResult
